import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { EMobilityWallboxPricesModel, EMobilityWallboxPricesResponse } from '../models/e-mobility-wallbox-models'
import { wallboxPricesToModelTransformer } from '../transformers/wallbox-prices-to-model.transformer'

/** This function is fetching prices for single wallbox
 * @param serialNo serial number of installation as string
 * @param authFetch authentication function as function
 * @param wallboxIndex corresponds to BE wb_id param as number
 * @returns prices model as promise
 */
export const fetchWallboxPrices = (
  serialNo: string,
  wallboxIndex: number,
  priceType: 'charge' | 'discharge',
  authFetch: <T>(props: FetchProps) => Promise<T>
): Promise<EMobilityWallboxPricesModel[]> => {
  const pricesResponse = authFetch<EMobilityWallboxPricesResponse>({
    path: `wallboxes/${serialNo}/${wallboxIndex}/prices/${priceType}`,
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    method: 'GET',
  })

  return pricesResponse
    .then(response => wallboxPricesToModelTransformer(response))
    .catch(e => {
      throw e
    })
}
